import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ERROR, QUOTING } from 'shared/data/quoteSteps';
import { selectAssemblyDataForPrices } from 'us_pcb_assembly/store/selectors';
import { priceSelected } from 'us_pcb_assembly/store/slice';
import { doEmailQuote } from 'us_pcb_assembly/store/thunks';

import PriceUs from 'us_pcb_assembly/components/PriceUS';
import PriceMX from 'us_pcb_assembly/components/PriceMX';
import AutomaticQuoteError from 'shared/components/AutomaticQuoteError';
import QuoteLoading from 'shared/components/price/QuoteLoading';

const Prices = () => {
  const dispatch = useDispatch();
  const {
    parameters,
    quote,
    quoteStep,
    parametersChanged,
    assemblyVariants,
  } = useSelector(selectAssemblyDataForPrices);

  if (quoteStep === ERROR) {
    return <AutomaticQuoteError />;
  }

  if (quoteStep === QUOTING) {
    return <QuoteLoading />;
  }

  const onPriceSelect = (data) => {
    const origin = data.supplier.split('-')[1];
    dispatch(priceSelected({ ...data, currentVariant: assemblyVariants[origin] }));
  };

  const onSendEmailQuote = (data, token) => dispatch(doEmailQuote({ data, token }));

  const props = {
    parameters,
    quote,
    quoteStep,
    parametersChanged,
    onPriceSelect,
    onSendEmailQuote,
    toggleLeadTimeRestrictions: false,
  };

  return (
    <div className="container-fluid quote-result">
      <PriceUs {...props} />
      <PriceMX {...props} />
    </div>
  );
};

export default Prices;
